// extracted by mini-css-extract-plugin
export default {"noWrap":"Label_noWrap__jMTt5","interactable":"Label_interactable__vcvh-"};